import React from "react";
import TechStack from "./TechStack";
import { Section } from "../App";

export default function Projects() {
  return <TechStack></TechStack>;
}
